import { Box, Typography, useTheme } from "@material-ui/core";
import React from "react";
import { formatMultilinesText } from "../../../../../helpers/markdown";
import { ProductVariantType } from "../../../../../types/airgraft";
import fastCompare from "react-fast-compare";

type Props = {
  productVariant: ProductVariantType;
};

function ProductDetailsDeviceTable({ productVariant }: Props) {
  const theme = useTheme();

  const descriptionLines = formatMultilinesText(
    productVariant.descriptionNode.childMarkdownRemark.html
  ).split("<br>");

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      justifyContent="space-between"
      borderTop={`2px solid ${theme.palette.grey[400]}`}
      borderBottom={`2px solid ${theme.palette.grey[400]}`}
      textAlign="left"
    >
      {descriptionLines.map((line, index) => {
        return (
          <Box
            key={line}
            display="flex"
            paddingY={1}
            borderTop={
              index !== 0 ? `1px solid ${theme.palette.grey[400]}` : undefined
            }
          >
            <Box pr={1} flex={1}>
              <Typography variant="body2">{line}</Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default React.memo(ProductDetailsDeviceTable, fastCompare);
